import { useEffect, useState } from 'react';
import { IconButton, Modal } from 'src/Components';
import { Headline } from 'src/UI';
import { useAppDispatch, useEQSelector } from 'src/Hooks';
import { Select2WebElementType } from 'src/Types/ReDoc';
import { damaskGetPauseReasons } from 'src/Slicers/eQueue/DamaskThunks';
import { SimpleSelect, EnumItemType } from 'src/Components/Controls';
import { ReactComponent as CapIcon } from '../Assets/Cup-modal.svg';
import { IModalProps } from '.';
import { EQueueType } from 'src/Types/ReDoc/EQueue';
import { enterGetPauseReasons } from 'src/Slicers/eQueue/EnterThunks';
import './modals.scss';
import './RedirectModal/RedirectModal.scss';

/** Модальное окно для выбора причины перерыва */
const ChoicePauseReasonsModal: React.FC<IModalProps> = ({
	type,
	isOpen,
	onClose,
	onAction,
}) => {
	const [winNumber, setWinNumber] = useState<string | string[]>('');

	const dispatch = useAppDispatch();
	const choices =
		useEQSelector<Select2WebElementType[]>(type, 'pauseReasons') || [];

	useEffect(() => {
		if (type === EQueueType.Damask) {
			dispatch(damaskGetPauseReasons());
		} else {
			dispatch(enterGetPauseReasons());
		}
		// eslint-disable-next-line
	}, []);

	/** Рендерит тело модального окна с выбором причины перерыва */
	const renderBody: React.FC = (props) => {
		return (
			<div className="modal_wrapper modal_wrapper-redirect">
				<p className="rdc_modal__content__text body-large">
					Вы действительно хотите уйти на перерыв?
				</p>
				<Headline>Выберите причину перерыва</Headline>
				<SimpleSelect
					isOwnerList
					options={getEnumsByChoiceses(choices)}
					value={winNumber}
					setValue={setWinNumber}
					placeholder="Выберите причину..."
				/>
			</div>
		);
	};

	/** Рендерит панель инструментов модального окна */
	const renderModalToolbar = () => {
		return (
			<>
				<IconButton outline onClick={onClose}>
					Отмена
				</IconButton>
				<IconButton
					disable={!winNumber}
					color="error"
					onClick={() => {
						return onAction('beginPause', winNumber);
					}}
				>
					Уйти
				</IconButton>
			</>
		);
	};

	return (
		<Modal
			isOpen={isOpen}
			title="Уйти на перерыв"
			onClose={onClose}
			color="error"
			renderIcon={<CapIcon />}
			className="not_scrolled"
			renderFooter={renderModalToolbar()}
			renderBody={renderBody}
		/>
	);
};

/** Преобразует массив элементов Select2WebElementType в массив EnumItemType для компонента SimpleSelect */
const getEnumsByChoiceses = (
	items: Select2WebElementType[],
): Array<EnumItemType> => {
	return items.map((item: Select2WebElementType) => {
		return {
			id: item.id,
			title: item.text || item.id,
		};
	});
};

export default ChoicePauseReasonsModal;
